import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface INewsletterSignupProps extends IBaseElementProps {
	/**
	 * Newsletter Signup Tagline
	 */
	tagline?: string;
	/**
	 * Newsletter Signup Heading
	 */
	heading?: string;
}

/**
 * Newsletter Signup
 * @block
 * @requiresHooks
 * @icon feedback
 */
const NewsletterSignup: React.FC<INewsletterSignupProps> = ({
	className,
	classNames = [],
	tagline,
	heading,
	children,
}) => (
	<div className={className || cn('newsletter', ...classNames)}>
		<div className="container">
			<div className="newsletter__content">
				{tagline && <h4 className="newsletter__tagline">{tagline}</h4>}
				{heading && <h2 className="newsletter__heading">{heading}</h2>}
			</div>
			<div className="newsletter__form">{children}</div>
		</div>
	</div>
);

export default NewsletterSignup;
